import api from './api';

export function postRiskLevelSoyYo(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/soyyo/validation`, data)
  }
